export const formatDateSubmit = (date?: string) => {
  if (!date) return '';
  const [day, month, year] = date.split('/').map(Number);
  return new Date(year, month - 1, day).toISOString();
};